import { useState, useEffect, useContext } from 'react';
import { A02 } from '../../api/U003';
import { AppContext } from 'templates/AppContextProvider';

export function useGetNews(lang: string): [
  {
    news_id: number;
    start_dtm: Date;
    news_title: string;
    news: string;
    file1: string;
    file2: string;
    file3: string;
    file4: string;
    file5: string;
  }[],
  boolean,
  Error | null,
] {
  const ctx = useContext(AppContext);
  const [loading, setLoading] = useState<boolean>(true);
  const [news, setNews] = useState<
    {
      news_id: number;
      start_dtm: Date;
      news_title: string;
      news: string;
      file1: string;
      file2: string;
      file3: string;
      file4: string;
      file5: string;
    }[]
  >([]);
  const [err, setError] = useState<Error | null>(null);

  const FetchNews = async (userId: string, lang: string, cancellation: AbortSignal) => {
    const json = await A02(userId, lang, cancellation);
    return json.news.map(
      (obj: {
        news_id: number;
        news_title: string;
        start_dtm: string;
        news: string;
        file1: string;
        file2: string;
        file3: string;
        file4: string;
        file5: string;
      }) => {
        return {
          news_id: obj.news_id,
          news_title: obj.news_title,
          start_dtm: new Date(obj.start_dtm),
          news: obj.news,
          file1: obj.file1,
          file2: obj.file2,
          file3: obj.file3,
          file4: obj.file4,
          file5: obj.file5,
        };
      }
    );
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    async function fetch() {
      if (!ctx.userId) return;
      try {
        setLoading(true);
        setError(null);
        const news = await FetchNews(ctx.userId, lang, signal);
        setNews(news);
      } catch (err) {
        if (err instanceof DOMException && err.message === 'signal is aborted without reason')
          return;
        if (err instanceof Error) {
          setError(err);
        } else {
          setError(new Error(`unknown error. ${err}`));
        }
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      controller.abort();
    };
  }, [ctx.userId, lang]);

  return [news, loading, err];
}
